import { render, staticRenderFns } from "./complications.vue?vue&type=template&id=24015c64"
import script from "./complications.vue?vue&type=script&lang=js"
export * from "./complications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports